import { BASE_URL } from "config";
// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import AddUserModal from "components/AddUserModal";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));
export default function AdsTableData(users, handleEditClick, fetchUsers) {
  const [isActive, setIsActive] = useState(true);

  const handleSwitch = () => {
    setIsActive(!isActive);
  };
  const editFunction = (user) => {
    console.log(user);
  };
  const handleDeletion = async (user) => {
    // التحقق من الصلاحيات أولًا
    if (user.type === "administrator") {
      Swal.fire({
        icon: "error",
        title: "غير مسموح!",
        text: "صلاحيات الحذف مقصورة على المشرفين",
        confirmButtonText: "حسنًا",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
      return;
    }

    // رسالة تأكيد احترافية
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف المستخدم "${user.name}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      customClass: {
        title: "text-danger",
        confirmButton: "btn btn-danger mx-2",
        cancelButton: "btn btn-secondary mx-2",
      },
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const token = localStorage.getItem("user-token");
          const response = await axios.get(`${BASE_URL}/administrator/ads/delete/${user.id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });

    // معالجة النتيجة
    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف المستخدم بنجاح",
        });
        fetchUsers();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };
  const handleActivation = async (user, isActive) => {
    if (user.type == "administrator") {
      Swal.fire({
        icon: "error",
        title: "فشل تحديث حالة المستخدم",
        text: "ليس لديك صلاحية تعديل حالة المسؤول",
      });
      return;
    }
    try {
      const token = localStorage.getItem("user-token");
      const response = await axios.get(`${BASE_URL}/administrator/ads/active/${user.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response);
      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "تم التحديث!",
          text: "تم تغيير حالة المستخدم بنجاح",
        });
        // قم بتحديث الحالة المحلية إذا لزم الأمر
        fetchUsers(); // إعادة جلب البيانات من السيرفر
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "فشل التحديث!",
        text: error.response?.data?.message || "حدث خطأ أثناء التحديث",
      });
    }
  };
  const Author = ({ name, email, image }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar
        src={image}
        name={name}
        size="sm"
        sx={{
          // 1. الخلفية الرمادية عند عدم وجود صورة
          backgroundColor: !image ? "grey.300" : "rgba(0, 0, 0, 0)",
          // 2. تحديد الحجم الجديد
          width: 40,
          height: 40,
          // 3. التأكد من الشكل الدائري
          borderRadius: "50%",
          // 4. تنسيق محتوى الأيقونة
          "& .MuiSvgIcon-root": {
            fontSize: "1rem", // تكبير حجم الأيقونة
          },
        }}
      >
        {!image && <PersonIcon fontSize="small" />}
      </MDAvatar>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const Status = ({ isActive }) => (
    <MDBox ml={-1}>
      <MDBadge
        badgeContent={isActive ? "مفعل" : "غير مفعل"}
        color={isActive ? "success" : "dark"}
        variant="gradient"
        sx="larg"
      />
    </MDBox>
  );

  return {
    columns: [
      { Header: "عنوان الاعلان", accessor: "title", width: "150px", align: "left" },
      { Header: "الصورة", accessor: "image", align: "center" },
      { Header: "الشاشة", accessor: "screen", align: "center" },
      { Header: "النوع", accessor: "type", align: "center" },
      { Header: "الرابط", accessor: "link", width: "100px", align: "center" },
      { Header: "الحالة", accessor: "status", align: "center" },
      { Header: "الهدف", accessor: "target", width: "10%", align: "center" },
      { Header: "تاريخ البداية", accessor: "starts_at", align: "center" },
      { Header: "تاريخ النهاية", accessor: "ends_at", align: "center" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],

    rows: users.map((ad) => ({
      title: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {ad.title}
        </MDTypography>
      ),
      image: <MDAvatar src={ad.image} alt={ad.title} size="sm" variant="rounded" />, // صورة مصغرة فقط
      screen: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {ad.context_id}
        </MDTypography>
      ),
      link: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {ad.target_url}
        </MDTypography>
      ),
      type: (
        <MDTypography variant="caption" color="text" fontWeight="medium" width="100px">
          {(() => {
            switch (ad.target_type) {
              case "url":
                return "رابط";
              case "product":
                return "منتج";
              case "category":
                return "فئة";
              case "vendor":
                return "مزود";
              case "event":
                return "فعالية";
              default:
                return ad.target_type;
            }
          })()}
        </MDTypography>
      ),
      status: (
        <MDBadge
          badgeContent={ad.is_active ? "مفعل" : "غير مفعل"}
          color={ad.is_active ? "success" : "dark"}
          variant="gradient"
        />
      ),
      target: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {(() => {
            if (ad.target_type === "url")
              return (
                <a
                  href={ad.target_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1976d2", textDecoration: "underline" }}
                >
                  {ad.target_url}
                </a>
              );
            if (ad.target_type === "product") return ad.product_name || ad.target_id;
            if (ad.target_type === "category") return ad.category_name || ad.target_id;
            if (ad.target_type === "vendor") return ad.vendor_name || ad.target_id;
            if (ad.target_type === "event") return ad.event_name || ad.target_id;
            return "-";
          })()}
        </MDTypography>
      ),
      starts_at: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {ad.starts_at ? ad.starts_at.replace("T", " ").slice(0, 19) : "-"}
        </MDTypography>
      ),
      ends_at: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {ad.ends_at ? ad.ends_at.replace("T", " ").slice(0, 19) : "-"}
        </MDTypography>
      ),
      action: (
        <MDBox
          display="flex"
          alignItems="center"
          gap={1}
          p={1}
          borderRadius="lg"
          bgcolor="background.paper"
          boxShadow={1}
        >
          <CustomSwitch
            checked={Boolean(ad.is_active)}
            onChange={(e) => handleActivation(ad, e.target.checked)}
            color="default"
          />
          <IconButton
            aria-label="edit"
            sx={{
              color: "info.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleEditClick(ad)}
          >
            <EditIcon fontSize="medium" />
          </IconButton>
          <IconButton
            aria-label="delete"
            sx={{
              color: "error.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleDeletion(ad)}
          >
            <DeleteIcon fontSize="medium" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
